import React from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  VStack,
} from '@chakra-ui/react';

interface LeadRateFormProps {
  data: Record<string, any>;
  options: Record<string, any[]>;
  onChange: (data: Record<string, any>) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export default function LeadRateForm({
  data,
  options,
  onChange,
  onSubmit,
  isSubmitting,
}: LeadRateFormProps) {
  const set = (key: string, value: any) => onChange({ ...data, [key]: value });

  return (
    <VStack align="stretch" spacing={3}>
      <SimpleGrid columns={2} spacing={3}>
        <FormControl>
          <FormLabel fontSize="xs">Class Code</FormLabel>
          <Input
            size="sm"
            value={data.code ?? ''}
            onChange={(e) => set('code', e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="xs">Description</FormLabel>
          <Input
            size="sm"
            value={data.description ?? ''}
            onChange={(e) => set('description', e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="xs">Rate</FormLabel>
          <Input
            size="sm"
            type="number"
            step="any"
            value={data.rate ?? ''}
            onChange={(e) => set('rate', Number(e.target.value))}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="xs">State</FormLabel>
          <Input
            size="sm"
            value={data.state ?? ''}
            onChange={(e) => set('state', e.target.value.toUpperCase())}
            maxLength={2}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="xs">Year</FormLabel>
          <Input
            size="sm"
            value={data.year ?? ''}
            onChange={(e) => set('year', e.target.value)}
            maxLength={4}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="xs">Employees</FormLabel>
          <Input
            size="sm"
            type="number"
            value={data.employees ?? ''}
            onChange={(e) => set('employees', Number(e.target.value))}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="xs">Payroll</FormLabel>
          <Input
            size="sm"
            type="number"
            step="any"
            value={data.payroll ?? ''}
            onChange={(e) => set('payroll', Number(e.target.value))}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="xs">Comp Policy</FormLabel>
          <Select
            size="sm"
            value={data.comp_policy_id ?? ''}
            onChange={(e) => set('comp_policy_id', Number(e.target.value))}
          >
            <option value="">—</option>
            {options.comp_policies?.map((p: any) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </Select>
        </FormControl>
      </SimpleGrid>

      <Button
        colorScheme="purple"
        size="sm"
        onClick={onSubmit}
        isLoading={isSubmitting}
        alignSelf="flex-start"
      >
        Add Rate
      </Button>
    </VStack>
  );
}
